/*
 * Rooana: цветни кръгчета за нюанс на продуктовите страници (snippets/product-variant-picker.liquid).
 * - Кръгчето се оцветява от снимката на варианта (canvas, доминантен наситен цвят).
 * - Ключови думи в името (black, olive, grey, white, sand) имат предимство, защото опаковката подвежда извличането.
 * - Цветовете се кешират в sessionStorage, за да не мигат при смяна на варианта (темата пререндерира избора).
 * - Ако цвят не може да се определи, остава мини снимката на варианта.
 */
(function () {
  if (window.__rooanaPdpSwatches) return;
  window.__rooanaPdpSwatches = true;

  var KEYWORDS = [
    [/olive/i, '#6a6b3b'],
    [/black/i, '#1d1b1c'],
    [/\bgrey\b/i, '#77767a'],
    [/\bwhite\b/i, '#f3f1ec'],
    [/\bsand\b/i, '#e9d6bd']
  ];
  var STORE = 'rooanaShadeColors';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { cache = {}; }
  function save() { try { sessionStorage.setItem(STORE, JSON.stringify(cache)); } catch (e) {} }

  function apply(el, color) {
    if (!color) return;
    el.style.setProperty('--sw', color);
    el.classList.add('has-color');
  }

  function fromKeyword(name) {
    for (var i = 0; i < KEYWORDS.length; i++) if (KEYWORDS[i][0].test(name || '')) return KEYWORDS[i][1];
    return null;
  }

  function extract(src, done) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var s = 80, c = document.createElement('canvas');
        c.width = s; c.height = s;
        var x = c.getContext('2d');
        x.drawImage(im, 0, 0, s, s);
        var d = x.getImageData(0, 0, s, s).data, b = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], bl = d[i + 2];
          var mx = Math.max(r, g, bl), mn = Math.min(r, g, bl);
          if (mn > 225) continue;
          var sat = mx ? (mx - mn) / mx : 0;
          if (sat < 0.18 || mx < 40) continue;
          var k = (r >> 5) + ',' + (g >> 5) + ',' + (bl >> 5);
          var e = (b[k] = b[k] || [0, 0, 0, 0, 0]);
          e[0] += r; e[1] += g; e[2] += bl; e[3]++; e[4] += sat;
        }
        var best = null, bs = 0;
        for (var key in b) {
          var en = b[key], sc = en[3] * Math.pow(en[4] / en[3], 1.5);
          if (sc > bs) { bs = sc; best = en; }
        }
        if (!best || best[3] < 6) return done('');
        done('rgb(' + [best[0] / best[3], best[1] / best[3], best[2] / best[3]].map(Math.round).join(',') + ')');
      } catch (err) { done(''); }
    };
    im.onerror = function () { done(''); };
    im.src = src;
  }

  function paint(el) {
    el.setAttribute('data-sw-done', '');
    var kw = fromKeyword(el.getAttribute('data-shade'));
    if (kw) return apply(el, kw);
    var src = el.getAttribute('data-sw-src');
    if (!src) return;
    if (Object.prototype.hasOwnProperty.call(cache, src)) return apply(el, cache[src]);
    extract(src, function (color) {
      cache[src] = color;
      save();
      apply(el, color);
    });
  }

  function run() {
    document.querySelectorAll('.rooana-shade:not([data-sw-done])').forEach(paint);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();